import { setInterval } from 'core-js';
import React, { useEffect, useLayoutEffect, useMemo, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { externalLinkOpen } from '../../../../actions/externallink';
import { getRedirectUrl, RedirectServices } from '../../../../config/urls';
import useMergeProps from '../../../../hooks/useMergeProps';
import { StateType } from '../../../../states';
import { storage } from '../../../../utils';
import { LocalStorageMissionsKeys } from '../../constants/storage';

import MissionsCardsList from './MissionsCardsList';
import selectMissionsCardsListContainerProps from './MissionsCardsList.selector';

type MissionsCardsListContainerProps = {
  className?: string;
};

const MissionsCardsListContainer = (ownProps: MissionsCardsListContainerProps) => {
  const dispatch = useDispatch();
  const [refresh, setRefresh] = useState(false);
  const selectorProps = useMemo(() => ({ refresh }), [refresh]);
  const selectedProps = useSelector((state: StateType) => selectMissionsCardsListContainerProps(state, selectorProps));

  const onMoreMissionsClick = useCallback(() => {
    dispatch(
      externalLinkOpen(getRedirectUrl(RedirectServices.OFFERS), {
        auth: true,
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    if (selectedProps?.activeMissionIds?.length > 0) {
      storage.localStorage.save(LocalStorageMissionsKeys.SEEN_MISSIONS, selectedProps?.activeMissionIds);
    }
  }, [selectedProps]);

  useLayoutEffect(() => {
    const pid = setInterval(() => {
      setRefresh((prev) => !prev);
    }, 10000);

    return () => {
      clearInterval(pid);
    };
  }, []);

  const otherProps = useMemo(
    () => ({
      onMoreMissionsClick,
    }),
    [onMoreMissionsClick],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <MissionsCardsList {...enhancedProps} />;
};

export default MissionsCardsListContainer;
